import { __awaiter } from "tslib";
import { useQuery, useSuspenseQueries, useSuspenseQuery, } from "@tanstack/react-query";
import { Configuration as ApiConfiguration, ConfigurationApi, } from "@plansoft-configuration-renderer/configuration-api";
/**
 * Returns the data of the current layout
 * - can be used outside of {@linkcode ConfigurationController}
 * @param options
 * @returns
 */
export function useLayoutData(options) {
    var _a;
    const { data, isError, isFetching } = useLayoutInfoQuery(options);
    const isReady = !isFetching;
    const layout = (_a = data === null || data === void 0 ? void 0 : data.custom) !== null && _a !== void 0 ? _a : null;
    const hasError = isError || !layout;
    return { isReady, hasError, layout };
}
export function useLayoutDataSuspense(options) {
    var _a;
    const { data, isError, isFetching } = useLayoutInfoSuspenseQuery(options);
    const isReady = !isFetching;
    const layout = (_a = data === null || data === void 0 ? void 0 : data.custom) !== null && _a !== void 0 ? _a : null;
    const hasError = isError || !layout;
    return { isReady, hasError, layout };
}
function buildLayoutInfoQueryOptions(options) {
    const { cfgObjectId, rootCfgObjectId, basePath } = options;
    // we can only use preselect of layout at top level
    const canLayoutIdBeUsed = rootCfgObjectId === cfgObjectId;
    const layoutId = canLayoutIdBeUsed ? options.layoutId : undefined;
    return {
        queryKey: [
            "ConfigurationApi.getLayouts",
            basePath,
            cfgObjectId,
            rootCfgObjectId,
            layoutId,
        ],
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({}) {
            const api = new ConfigurationApi(new ApiConfiguration({ basePath }));
            const layout = api.getLayouts({ cfgObjectId, rootCfgObjectId, layoutId });
            return layout;
        }),
        retry: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        throwOnError: false,
    };
}
function useLayoutInfoQuery(options) {
    return useQuery(buildLayoutInfoQueryOptions(options));
}
function useLayoutInfoSuspenseQuery(options) {
    return useSuspenseQuery(buildLayoutInfoQueryOptions(options));
}
export function useLayoutSuspenseRecord(options) {
    const { cfgObjectIds, rootCfgObjectId, layoutId, basePath } = options;
    return useSuspenseQueries({
        queries: cfgObjectIds.map((cfgObjectId) => buildLayoutInfoQueryOptions({
            cfgObjectId,
            rootCfgObjectId,
            basePath,
            layoutId,
        })),
        combine: (results) => {
            return {
                layouts: results.reduce((acc, result, index) => {
                    var _a;
                    const cfgObjectId = cfgObjectIds[index];
                    if (!((_a = result.data) === null || _a === void 0 ? void 0 : _a.custom)) {
                        return acc;
                    }
                    return Object.assign(Object.assign({}, acc), { [cfgObjectId]: result.data.custom });
                }, {}),
                isPending: results.some((result) => result.isPending),
            };
        },
    });
}
//# sourceMappingURL=useLayoutData.js.map